import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { AccessControls, MuiButton } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import {
  ActionsEnum,
  DrawerType,
  isEntityWithoutGenericUpload,
  useDrawers,
} from "@ryde/shared";

export const HeaderBottomGenericUploadButton = (): ReactNode => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const { openDrawer } = useDrawers();

  const handleClick = (): void => {
    openDrawer({
      drawerProps: {
        type: DrawerType.GenericUpload,
        entity,
      },
    });
  };

  if (isEntityWithoutGenericUpload(entity)) {
    return null;
  }

  return (
    <AccessControls
      actionsList={[
        { entity, action: ActionsEnum.Create },
        { entity: "system", action: ActionsEnum.AllowImport },
      ]}
    >
      <MuiButton
        e2eData="generic-upload-button"
        onClick={handleClick}
        sx={{ flexShrink: 0 }}
      >
        {t("general.UPLOAD_A_NEW_ENTITY")}
      </MuiButton>
    </AccessControls>
  );
};
